import { Component, OnInit, TemplateRef } from '@angular/core';
import { GuiaremisionService } from '../../../services/guiaremision.service';
import { SucursalService } from '../../../services/sucursal.service';
import { ClienteService } from '../../../services/cliente.service';
import { Guiaremision } from './../../../models/guiaremision';
import { Router } from '@angular/router';
import { AsyncLocalStorage } from 'angular-async-local-storage';
import { SweetMessage } from '../../../config/sweet-message';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { GuiaremisionModalComponent } from '../../../components/modals/guiaremision-modal/guiaremision-modal.component';
import { ReenviarCorreoComponent } from '../../../components/modals/reenviar-correo/reenviar-correo.component';
import { SessionService } from '../../../services/session.service';
import { ReporteModalComponent } from '../../../components/modals/reporte-modal/reporte-modal.component';
import { ConfirmacionAnulacionModalComponent } from '../../../components/modals/confirmacion-anulacion-modal/confirmacion-anulacion-modal.component';
import { ConfigService } from '../../../config/config-service';
import * as numeral from 'numeral';
import * as moment from 'moment';
import { environment } from '../../../../environments/environment';
import { Pagination } from '../../../models/pagination';

@Component({
  selector: 'app-guiaremision-list',
  templateUrl: './guiaremision-list.component.html',
  styleUrls: ['./guiaremision-list.component.css'],
  providers: 
  [ GuiaremisionService,
	SucursalService,
	ClienteService
  ]
})
export class GuiaremisionListComponent implements OnInit {
  public title: String;
	public guias: Array<Guiaremision> = [];
	public msg: SweetMessage;
	public bsModalRef: BsModalRef;
	public bsModalRef2: BsModalRef;
	public loading = false;
	public config: ConfigService;
	public guia_anulada: Guiaremision;
	public observacion: String;
	public total: number;
	public total_activas: number;
	public total_anuladas: number;
	public Mod_FactElec: string;
	public factelec_api: String;
	public pagination: Pagination;
	
  constructor(
		public guiaremisionService: GuiaremisionService,
		public sucursalService: SucursalService,
		public clienteService: ClienteService,
		private NavRoute: Router,
		private storage: AsyncLocalStorage,
		private modalService: BsModalService,
		private ss: SessionService,
	) {
		this.title = "Guias de Remisión";
		this.config = new ConfigService();
		this.guia_anulada = new Guiaremision();
		this.observacion = "";
		this.total = 0;
		this.total_activas = 0;
		this.total_anuladas = 0;
		this.Mod_FactElec = this.ss.getData("mod_felectronica");
		this.factelec_api = environment.factelec_api;
		this.pagination = new Pagination();
	}

	ngOnInit() {
		this.msg = new SweetMessage();
			this.loading = true;
			this.getGuias().then(
				res => this.loading = false,
				err => this.loading = false
			);
	}

  	getGuias() {
    return new Promise((resolve, reject) => {
			this.pagination.current_page = 1;
			let today = moment().format("YYYY-MM-DD");
			//"?fecha_emision=" + today +
			this.guiaremisionService.getAll("?embed=tipocomprobante,cliente,estadobitacora&sort=-id&usuario_id="+this.ss.getData('usuario_id')+"?page="+this.pagination.current_page+'&per_page=10'+"&fecha_emision=" + today).subscribe(
				res => {
					this.guias = res.data;
					this.pagination.current_page = res.current_page;
					this.pagination.from = res.from;
					this.pagination.to = res.to;
					this.pagination.total = res.total;
					this.pagination.last_page = res.last_page;
					this.pagination.next_disabled = (this.pagination.current_page === this.pagination.last_page);
					this.pagination.prev_disabled = this.pagination.current_page === 1;
					resolve();
				},
				err => {
					this.guias = [];
					reject(err);
				}
			);
		});

	}

	onShow(id){
		const initialState = {guiaremision_id: id};
		this.bsModalRef = this.modalService.show(GuiaremisionModalComponent, Object.assign({}, {class: 'modal-xlg', initialState}));
	}

	onStatusElectronica(guiaremision){
		let msn = "";
		msn += "<p>Estado de Factura Electrónica</p>";
		msn += "<p><b style='font-size:24px;'>"+guiaremision.estadobitacora.descripcion+"</b></p>";

		this.msg.showMessage('single-message', msn);
	}

	OnReenviar1(guiaremision, btn: HTMLInputElement){
		this.msg.showMessage('delete-confirm-message',"Está seguro de reenviar el correo al cliente: <br /> <b>" + guiaremision.cliente.nombre_comercial + "</b><br> <b>" + guiaremision.cliente.correo + "</b>").then(
			res => {
				if(res == "ok"){
					btn.disabled = true;
					btn.innerHTML = "<i class='fa fa-refresh fa-spin'></i>";

					let data = {
						"correo": guiaremision.cliente.correo,
						"clave": guiaremision.numero_autorizacion,
						"usuario_id": this.ss.getData('facelect_usuario_id')
					};
					this.guiaremisionService.ReenviarElectronica(data).subscribe(
						() => {
							btn.disabled = false;
							btn.innerHTML = "<i class='fa fa-envelope'></i>";
						},
						() => {
							btn.disabled = false;
							btn.innerHTML = "<i class='fa fa-envelope'></i>";
						}
					);
				}
			}
		);
	}

	OnReenviar(guiaremision){
        const initialState = { nombre: guiaremision.cliente.nombre_comercial, correo: guiaremision.cliente.correo, autorizacion: guiaremision.numero_autorizacion };
		this.bsModalRef = this.modalService.show(ReenviarCorreoComponent, Object.assign({}, {initialState}));
    }

	onReport(guiaremision){
		if(this.CodEst(guiaremision) === 'btn-success'){
			const initialState = {host_api: this.factelec_api, route: "/" + this.ss.getData('fact_user') + "/ride/" + guiaremision.numero_autorizacion, qs: "?tk=" + this.ss.getData('fact-api-token')};
			this.bsModalRef = this.modalService.show(ReporteModalComponent, Object.assign({}, {class: 'modal-xlg', initialState}));
		}
	}

	onXML(guiaremision){
		if(this.CodEst(guiaremision) === 'btn-success'){
			const initialState = {host_api: this.factelec_api, route: "/" + this.ss.getData('fact_user') + "/xml/" + guiaremision.numero_autorizacion, qs: "?tk=" + this.ss.getData('fact-api-token')};
			this.bsModalRef = this.modalService.show(ReporteModalComponent, Object.assign({}, {class: 'modal-xlg', initialState}));
		}
	}

	CodEst(guiaremision){
		let cod_ests = ['NAT', 'NFIR', 'NLOG', 'DEV', 'TOT', 'FEC'];
		let result = cod_ests.filter(cod_est => cod_est === guiaremision.cod_est);

		if( result.length > 0 ){
			return 'btn-danger';
		}

		cod_ests = ['VAL', 'PPR', 'EP'];
		result = cod_ests.filter(cod_est => cod_est === guiaremision.cod_est);

		if( result.length > 0 ){
			return 'btn-warning';
		}

		cod_ests = ['AUT'];
		result = cod_ests.filter(cod_est => cod_est === guiaremision.cod_est);

		if( result.length > 0 ){
			return 'btn-success';
		}
	}

	openModalObservacion(template: TemplateRef<any>, guia: Guiaremision) {
		if( guia.status === 'A' && this.isAnulable(guia) ){
			if(guia.tipo_comprobante_id.toString() === "7"){
				let preg = "Recuerda que para anular algún comprobante primero debes anularlo desde <a href='https://declaraciones.sri.gob.ec/tuportal-internet/' target='_blank'>https://declaraciones.sri.gob.ec/tuportal-internet/</a>, posteriormente podrás anularlo desde esta opción. ¿Estás seguro que deseas continuar?";
				const initialState = { Pregunta: preg, Respuesta:false };
				this.bsModalRef = this.modalService.show(ConfirmacionAnulacionModalComponent, Object.assign({}, {initialState}));
				
				this.bsModalRef.content.action.take(1).subscribe((Respuesta) => {
					if(Respuesta == true){
						this.observacion = guia.observacion;
						this.guia_anulada = guia;
						this.bsModalRef = this.modalService.show(template);
						this.bsModalRef2 = this.bsModalRef;
					}
				});
			}else{
				this.observacion = guia.observacion;
				this.guia_anulada = guia;
				this.bsModalRef = this.modalService.show(template);
				this.bsModalRef2 = this.bsModalRef;
			}
		}
	}

	anularGuia(){
		this.bsModalRef2.hide();
		let preg = "¿Está seguro de querer anular el documento?";
		const initialState = { Pregunta: preg, Respuesta:false };
		this.bsModalRef = this.modalService.show(ConfirmacionAnulacionModalComponent, Object.assign({}, {initialState}));

		this.bsModalRef.content.action.take(1).subscribe((Respuesta) => {
			if(Respuesta == true){
				this.guia_anulada.observacion = this.observacion.toString().trim();
				this.observacion  = "";
				
				this.loading = true;

				this.guiaremisionService.anular(this.guia_anulada).subscribe(
					res => {
						this.bsModalRef.hide();
						this.guia_anulada = new Guiaremision();

						this.msg.showMessage('success-message', 'Se ha procesado correctamente');

						this.getGuias().then(
							res => {
								this.loading = false;
							},
							err => {
								this.loading = false;
							}
						);
					},
					err => {
						this.loading = false;
					}
				);
			}
			else{
				return;
			}
		});
	}

	isAnulable(guiaremision: Guiaremision){
		return true;

        /*let f = moment();
        let fecha = f.format("YYYY") + "-" + f.format("MM") + "-01";
        let fecha_inicio = moment(fecha,"YYYY-MM_DD").format('YYYY-MM-DD');
        let fecha_fin = moment().endOf('month').format('YYYY-MM-DD');
        let fecha_emision = moment(guiaremision.fecha_emision.toString(),"YYYY-MM_DD");

        return fecha_emision.isSameOrAfter(fecha_inicio) && fecha_emision.isSameOrBefore(fecha_fin);*/
	}
	
	next(){
		this.pagination.current_page++;
		this.getGuias();
	}

	prev(){
		this.pagination.current_page--;
		this.getGuias();
	}

	first(){
		this.pagination.current_page = 1;
		this.getGuias();
	}

	last(){
		this.pagination.current_page = this.pagination.last_page;
		this.getGuias();
	}
}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/ventas/guiaremision-list/guiaremision-list.component.ts